import { APIMethod, fetchData } from "@client";

export async function sendContactMessageQuery(description) {
  await fetchData("/feedback", APIMethod.POST, { data: { description } });
}
